<template>
  <h1 :style="{ textAlign: 'center', alignItems: 'center' }">Home</h1>
</template>

<script>
export default {};
</script>
